import { render, staticRenderFns } from "./EditDescriptionDialog.vue?vue&type=template&id=671c961a&scoped=true&"
import script from "./EditDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./EditDescriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditDescriptionDialog.vue?vue&type=style&index=0&id=671c961a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c961a",
  null
  
)

export default component.exports